'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDBTNCONF = exports.IDFIELD = exports.MODEL = undefined;
exports.findItem = findItem;
exports.getKey = getKey;
exports.getNewTime = getNewTime;
exports.hasNew = hasNew;
exports.buildTimeline = buildTimeline;

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

var _data = require('../../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var MODEL = exports.MODEL = {
  colorField: "color"
};
var IDFIELD = exports.IDFIELD = "_pkCode";
var ADDBTNCONF = exports.ADDBTNCONF = {
  label: "新增",
  size: "xsmall",
  type: "ghost",
  icon: "plus"
};

/**
 * 获取时间版本的对象
 * @param array 时间版本列表
 * @param key 时间版本key
 * @returns {*}
 */
function findItem(array, key) {
  if (Array.isArray(array) && !(0, _data.isEmptyString)(key)) {
    return array.find(function (v) {
      return IDFIELD in v && key === v[IDFIELD];
    });
  }
  return null;
}
/**
 * 获取时间版本的key
 * @param model 配置文件
 * @param date 时间版本对象
 * @param defaultKey 如果 model.idFied 不存在, 返回 defaultKey
 * @returns {*}
 */
function getKey(model, date, defaultKey) {
  if (!(0, _data.isObject)(model) || !(0, _data.isObject)(date) || !model.idField) {
    return (0, _data.isEmptyString)(defaultKey) ? '' : defaultKey;
  }
  if (model.idField.match("{{.*}}")) {
    return _util2.default.template(model.idField, date || {});
  }
  return date[model.idField];
}
/**
 * 获取新增节点
 * @param model
 * @returns {{_new: boolean}}
 */
function getNewTime(model) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, IDFIELD, "_new"), _defineProperty(_ref, '_new', true), _defineProperty(_ref, model.leftField, "新增中..."), _ref;
}
/**
 * 是否有新增中
 * @param date
 * @returns {boolean}
 */
function hasNew(date) {
  return Array.isArray(date) && date.some(function (v) {
    return v._new;
  });
}
/**
 * 为时间轴数据加上主键
 * @param model
 * @param date
 * @returns {boolean|*}
 */
function buildTimeline(model, date) {
  return Array.isArray(date) && date.map(function (item, index) {
    item[IDFIELD] = getKey(model, item, index);
    return item;
  });
}